import { TFunction } from 'i18next';
import { match, P } from 'ts-pattern';
import { getTranslation } from '../../../constants/systemValuesTranslation';
import {
  MetricGroupId,
  SingleValueTimeSelectionInput,
} from '../../api/types-graphql';
import { format } from '../../date/date-utils';
import {
  MetricIdType,
  SegmentBy,
  TimeSelection,
  TimeSelectionType,
} from '../../types';

export const showTimeSelection = (
  timeSelection: TimeSelection,
  t: TFunction
) => {
  return match(timeSelection)
    .with(
      {
        type: TimeSelectionType.CalendarYearSingleValueByMonths,
        input: P.select(),
      },
      (input: SingleValueTimeSelectionInput) => {
        if (input.start === input.end) {
          return t('common:customDashboard.timeSelection.pointInTime', {
            selection: format((input.start as Date).valueOf()),
          });
        } else {
          return t('common:customDashboard.timeSelection.range', {
            start: format((input.start as Date).valueOf()),
            end: format((input.end as Date).valueOf()),
          });
        }
      }
    )
    .otherwise(() => {
      throw Error('not implemented');
    });
};

export const showTimeSelectionShortFormat = (
  timeSelection: TimeSelection,
  t: TFunction
) => {
  return match(timeSelection)
    .with(
      {
        type: TimeSelectionType.CalendarYearSingleValueByMonths,
        input: P.select(),
      },
      (input: SingleValueTimeSelectionInput) => {
        if (input.start === input.end) {
          return t('common:customDashboard.timeSelection.pointInTime', {
            selection: input.start as string,
          });
        } else {
          return t('common:customDashboard.timeSelection.range', {
            start: input.start as string,
            end: input.end as string,
          });
        }
      }
    )
    .otherwise(() => {
      throw Error('not implemented');
    });
};

// TODO: Rewrite these functions a bit eventually but for now these are fine
export const showMetric = (
  metric: MetricIdType,
  metricGroup: MetricGroupId,
  metricGroupAlias: string | null,
  t: TFunction
) => {
  return `${
    metricGroupAlias ??
    t(`common:metrics.metricGroupIds.${metricGroup}`, {
      defaultValue: metricGroup,
    })
  } (${t(`common:metrics.metricIds.${metric.value}`, {
    defaultValue: metric.value,
  })})`;
};

export const showTitle = (
  metricDisplayValue: string,
  title?: string,
  segmentations?: SegmentBy[]
): string => {
  if (title) {
    return title;
  } else {
    return `${metricDisplayValue}${
      segmentations
        ? ` by ${segmentations.map((s) => getTranslation(s.dataField)).join(' ')}`
        : ''
    }`;
  }
};
